import '../assets/NcSettingsSection-Dyrgo_fF.css';
import { r as register, n as t24, a as t } from "./_l10n-dinIMiE_.mjs";
import { createElementBlock, openBlock, mergeProps, createElementVNode, createCommentVNode, toDisplayString, resolveComponent, renderSlot, createTextVNode, createVNode } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
register(t24);
const _sfc_main$1 = {
  name: "HelpCircleIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
const _hoisted_1$1 = ["aria-hidden", "aria-label"];
const _hoisted_2$1 = ["fill", "width", "height"];
const _hoisted_3$1 = { d: "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" };
const _hoisted_4$1 = { key: 0 };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", mergeProps(_ctx.$attrs, {
    "aria-hidden": $props.title ? null : "true",
    "aria-label": $props.title,
    class: "material-design-icon help-circle-icon",
    role: "img",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }), [
    (openBlock(), createElementBlock("svg", {
      fill: $props.fillColor,
      class: "material-design-icon__svg",
      width: $props.size,
      height: $props.size,
      viewBox: "0 0 24 24"
    }, [
      createElementVNode("path", _hoisted_3$1, [
        $props.title ? (openBlock(), createElementBlock("title", _hoisted_4$1, toDisplayString($props.title), 1)) : createCommentVNode("", true)
      ])
    ], 8, _hoisted_2$1))
  ], 16, _hoisted_1$1);
}
const HelpCircle = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const _sfc_main = {
  name: "NcSettingsSection",
  components: {
    HelpCircle
  },
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    docUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      docNameTranslated: t("External documentation for {name}", {
        name: this.name
      })
    };
  },
  computed: {
    hasDescription() {
      return this.description.length > 0;
    },
    hasDocUrl() {
      return this.docUrl.length > 0;
    }
  }
};
const _hoisted_1 = { class: "settings-section" };
const _hoisted_2 = { class: "settings-section__name" };
const _hoisted_3 = ["href", "title", "aria-label"];
const _hoisted_4 = {
  key: 0,
  class: "settings-section__desc"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HelpCircle = resolveComponent("HelpCircle");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("h2", _hoisted_2, [
      createTextVNode(toDisplayString($props.name) + " ", 1),
      $options.hasDocUrl ? (openBlock(), createElementBlock("a", {
        key: 0,
        href: $props.docUrl,
        class: "settings-section__info",
        title: $data.docNameTranslated,
        "aria-label": $data.docNameTranslated,
        target: "_blank",
        rel: "noreferrer nofollow"
      }, [
        createVNode(_component_HelpCircle, { size: 20 })
      ], 8, _hoisted_3)) : createCommentVNode("", true)
    ]),
    $options.hasDescription ? (openBlock(), createElementBlock("p", _hoisted_4, toDisplayString($props.description), 1)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ]);
}
const NcSettingsSection = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-9a743cb1"]]);
export {
  NcSettingsSection as N
};
//# sourceMappingURL=NcSettingsSection-Crla6NXM.mjs.map
